<template>
  <table class="info-table" width="100%">
    <tr>
      <th>{{ title }}</th>
      <th>金额</th>
      <th>备注</th>
    </tr>
    <tr v-for="(item, index) in data" :key="index">
      <td>{{ item.name }}</td>
      <td>{{ item.value }}</td>
      <td>{{ item.tips }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'FinanceTable',
  props: {
    title: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    }
  }
};
</script>
<style lang="scss" scoped>
	.info-table {
		th {
			min-width: 100px;
			text-align: left;
			white-space: nowrap;
			padding: 8px 0 8px 10px;
		}

		td {
			min-width: 100px;
			border-right: 1px solid #eee;
			padding: 8px 0 8px 10px;
			white-space: normal;
		}
	}

	.hand {
		cursor: pointer;
	}

	.ML5 {
		margin-left: 5px;
	}

	.img {
		.el-image {
			width: 100px;
			height: 100px;
			margin-right: 10px;
		}
	}
</style>